module.exports = __webpack_public_path__ + "static/media/appleplay-store.39f7aa5d.png";